import {
  AdminDatePickerInputModal,
  AdminRadioInput,
  Disclaimer,
  Div,
  Tab,
} from '@vgrubs/components';
import { pauseUntilFormat } from '../Menu/MenuProviderSections/Items/itemPause.helpers';
import {
  PROVIDER_PAUSE_OPTIONS,
  PAUSE_END_BEFORE_START_ERROR,
  ProviderPauseStart,
  pauseFromError,
  pauseUntilBounds,
  pauseUntilError,
} from './providerPause';
import { ProviderPauseState } from './useProviderPause';

const STARTS: { name: string; value: ProviderPauseStart }[] = [
  { name: 'Now', value: 'now' },
  { name: 'Later', value: 'later' },
];

/**
 * The pause lengths. `Custom Time` opens the same date and time picker as the
 * item pause, held to today and tomorrow (to 11:59 PM) on the location's
 * clock, the longest a pause may run. Only `Custom Time` can start later:
 * the ready lengths always run from now.
 */
export const ProviderPauseOptions = ({
  pause,
  timeZone,
}: {
  pause: ProviderPauseState;
  timeZone?: string;
}) => {
  return (
    <Div $flex $column $gap="8px">
      {PROVIDER_PAUSE_OPTIONS.map(({ name, value }) => (
        <AdminRadioInput
          key={name}
          shadowDesign
          label={name}
          checked={value === pause.choice}
          onClick={() => pause.setChoice(value)}
        />
      ))}

      {pause.choice === 'until' && (
        <Div $flex $column $gap="16px" $mt="8">
          <Div>
            <Disclaimer $m="0 0 8px 0" $center>
              Starts
            </Disclaimer>
            {/* TabsWrapper is laid out for a page (bleeds out by 50px). */}
            <Div $flex $gap="16px" role="tablist">
              {STARTS.map(({ name, value }) => (
                <Tab
                  key={value}
                  $minWidthAuto
                  $width="calc(50% - 8px)"
                  selected={value === pause.start}
                  onClick={() => pause.setStart(value)}
                >
                  {name}
                </Tab>
              ))}
            </Div>
          </Div>

          {pause.start === 'later' && (
            <AdminDatePickerInputModal
              label="Paused From"
              format={pauseUntilFormat}
              value={pause.from}
              onChange={pause.setFrom}
              options={pauseUntilBounds(timeZone)}
              beforeApplyValidation={([date]) => pauseFromError(date, timeZone)}
              $textCenter
            />
          )}

          <AdminDatePickerInputModal
            label="Paused Until"
            format={pauseUntilFormat}
            value={pause.until}
            onChange={pause.setUntil}
            options={pauseUntilBounds(timeZone)}
            beforeApplyValidation={([date]) =>
              pauseUntilError(date, timeZone) ??
              (pause.isScheduled && pause.from[0] && date <= pause.from[0]
                ? PAUSE_END_BEFORE_START_ERROR
                : null)
            }
            $textCenter
          />
        </Div>
      )}
    </Div>
  );
};
